import { createContext } from "react";

const LikedItemsContext = createContext();

export default LikedItemsContext;
